import { Box } from "@mui/material";
import "./NavBarLogo.css"; 

export default function NavbarLogo({closed}: {closed: boolean}) {
    return(
        <Box className={`navbar-logo-container ${closed ? "closed" : ""}`} sx={{ color: "text.primary" }}>
            <Box
            className={`navbar-logo-image ${closed ? "closed" : ""}`}
            sx={{ color: "text.primary" }}
            >
                <img
                    src="/patient-pro.svg" 
                    alt="logo"
                    style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    }}
                />
            </Box>
            <Box 
            className={`navbar-logo-text ${closed ? "closed" : ""}`}
            sx={{ color: "text.primary" }}
            >
                Patient Pro
            </Box>
        </Box>
    )
}